module.exports = new __parcel__URL__("alex.26bbf3de.jpg").toString();